var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',{staticClass:"loader",attrs:{"line-fg-color":_vm.themeColorViolet,"line-bg-color":_vm.themeColorGreyLowTransp,"message":"LOADING","size":50,"spacing":20,"font-size":32,"text-fg-color":_vm.themeColorGreyHighTransp}})
}
var staticRenderFns = []

export { render, staticRenderFns }